module.exports = __webpack_public_path__ + "img/helyspecifikus_szolgaltatasok_pop_up.d25ce199.png";